<div class="fixed inset-0 z-50 flex items-center justify-center p-4 bg-slate-800/40 backdrop-blur-md animate-fade-in">

  <!-- Modal Card -->
  <div class="relative w-full max-w-md rounded-[2rem] overflow-hidden animate-fade-in-up
              bg-white dark:bg-slate-900/80
              backdrop-blur-xl
              border border-white/60 dark:border-slate-700/50
              shadow-[0_32px_80px_rgba(0,0,0,0.18),0_0_0_1px_rgba(255,255,255,0.06)]
              flex flex-col" style="max-height: 92vh;">

    <!-- ── Amber gradient top accent ── -->
    <div class="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-amber-300 via-amber-400 to-amber-300 z-10"></div>

    <!-- ── Header ── -->
    <div class="relative px-6 pt-7 pb-5 flex items-start gap-4 flex-shrink-0">

      <!-- Icon badge -->
      <div
        class="w-12 h-12 rounded-2xl bg-amber-400/20 border border-amber-400/30 flex items-center justify-center flex-shrink-0 shadow-[inset_0_1px_0_rgba(255,255,255,0.3)]">
        <span class="material-icons text-amber-500 text-2xl">receipt_long</span>
      </div>

      <!-- Title block -->
      <div class="flex-1 min-w-0">
        <p class="text-[9.5px] font-extrabold uppercase tracking-[0.15em] text-slate-400 dark:text-slate-500">
          รายละเอียดการรับชำระ</p>
        <h2 class="text-[16px] font-black tracking-tight text-slate-900 dark:text-white mt-0.5 truncate">
          {{ record?.receiptId || 'ไม่ระบุเลขใบเสร็จ' }}
        </h2>
        <!-- Status badge -->
        <span
          class="inline-flex items-center gap-1 mt-1.5 px-2.5 py-0.5 rounded-full text-[9.5px] font-black tracking-wide"
          [ngClass]="record?.statusId === '2'
            ? 'bg-rose-100/80 dark:bg-rose-950/40 text-rose-600 dark:text-rose-400 border border-rose-200/60 dark:border-rose-800/40'
            : (record?.pendingApprovalRequestId
              ? 'bg-amber-100/80 dark:bg-amber-950/40 text-amber-600 dark:text-amber-400 border border-amber-200/60 dark:border-amber-800/40'
              : 'bg-emerald-100/80 dark:bg-emerald-950/40 text-emerald-600 dark:text-emerald-400 border border-emerald-200/60 dark:border-emerald-800/40')">
          <span class="w-1.5 h-1.5 rounded-full inline-block"
            [ngClass]="record?.statusId === '2' ? 'bg-rose-500' : (record?.pendingApprovalRequestId ? 'bg-amber-500' : 'bg-emerald-500')"></span>
          {{ record?.status || '-' }}
        </span>
      </div>

      <!-- Close button -->
      <button (click)="onClose()" class="w-8 h-8 rounded-xl bg-slate-100/80 dark:bg-slate-800/60 hover:bg-slate-200/80 dark:hover:bg-slate-700/60
               text-slate-400 dark:text-slate-500 transition-all active:scale-95
               flex items-center justify-center flex-shrink-0 cursor-pointer border-none backdrop-blur-sm">
        <span class="material-icons text-[18px]">close</span>
      </button>
    </div>

    <!-- ── Divider ── -->
    <div
      class="mx-6 h-px bg-gradient-to-r from-transparent via-slate-200/80 dark:via-slate-700/50 to-transparent flex-shrink-0">
    </div>

    <!-- ── Scrollable Body ── -->
    <div class="overflow-y-auto flex-1 min-h-0 px-6 py-5 space-y-4 custom-scrollbar">

      <!-- Info Grid -->
      <div class="grid grid-cols-2 gap-3">

        <!-- Site -->
        <div
          class="col-span-2 bg-slate-50/80 dark:bg-slate-800/40 rounded-2xl px-4 py-3 border border-slate-100/80 dark:border-slate-700/40 backdrop-blur-sm">
          <p class="text-[8.5px] font-extrabold uppercase tracking-[0.12em] text-slate-400 dark:text-slate-500 mb-1">
            ลานจอดรถ (Site)</p>
          <p class="font-black text-[13px] text-slate-800 dark:text-slate-100">{{ record?.siteName || '-' }}</p>
        </div>

        <!-- Paid Date -->
        <div
          class="bg-slate-50/80 dark:bg-slate-800/40 rounded-2xl px-4 py-3 border border-slate-100/80 dark:border-slate-700/40 backdrop-blur-sm">
          <p class="text-[8.5px] font-extrabold uppercase tracking-[0.12em] text-slate-400 dark:text-slate-500 mb-1">
            วันที่ชำระเงิน</p>
          <p class="font-bold text-[12px] text-slate-700 dark:text-slate-300">{{ formatDateDisplay(record?.paidDate) }}
          </p>
        </div>

        <!-- Payment Channel -->
        <div
          class="bg-slate-50/80 dark:bg-slate-800/40 rounded-2xl px-4 py-3 border border-slate-100/80 dark:border-slate-700/40 backdrop-blur-sm">
          <p class="text-[8.5px] font-extrabold uppercase tracking-[0.12em] text-slate-400 dark:text-slate-500 mb-1">
            ช่องทางชำระ</p>
          <p class="font-bold text-[12px] text-slate-700 dark:text-slate-300">{{ record?.feeTypeName || '-' }}</p>
        </div>

        <!-- Fee Name -->
        <div
          class="col-span-2 bg-slate-50/80 dark:bg-slate-800/40 rounded-2xl px-4 py-3 border border-slate-100/80 dark:border-slate-700/40 backdrop-blur-sm">
          <p class="text-[8.5px] font-extrabold uppercase tracking-[0.12em] text-slate-400 dark:text-slate-500 mb-1">
            รายการบริการ (Fee Name)</p>
          <p class="font-bold text-[12px] text-slate-700 dark:text-slate-200">{{ record?.feeName || '-' }}</p>
        </div>
      </div>

      <!-- Financial Summary -->
      <div class="rounded-2xl overflow-hidden border border-slate-200/60 dark:border-slate-700/40">

        <!-- Header row -->
        <div
          class="px-4 py-2.5 bg-slate-100/60 dark:bg-slate-800/40 backdrop-blur-sm border-b border-slate-200/50 dark:border-slate-700/30">
          <p class="text-[8.5px] font-extrabold uppercase tracking-[0.14em] text-slate-400 dark:text-slate-500">
            สรุปข้อมูลการเงิน</p>
        </div>

        <!-- Rows -->
        <div class="px-4 py-3 bg-white/60 dark:bg-slate-900/40 backdrop-blur-sm space-y-2">
          <div class="flex justify-between items-center text-[11.5px]">
            <span class="text-slate-500 dark:text-slate-400">ค่าบริการสุทธิ (Net Fee)</span>
            <span class="font-bold text-slate-700 dark:text-slate-200">{{ record?.fee | number:'1.2-2' }} ฿</span>
          </div>
          <div class="flex justify-between items-center text-[11.5px]">
            <span class="text-slate-500 dark:text-slate-400">ภาษีมูลค่าเพิ่ม {{ vatSetting.rateLabel() }}% (VAT)</span>
            <span class="font-bold text-slate-700 dark:text-slate-200">{{ record?.vat | number:'1.2-2' }} ฿</span>
          </div>
          <div class="flex justify-between items-center text-[11.5px]">
            <span class="text-slate-500 dark:text-slate-400">หักภาษี ณ ที่จ่าย (WHT)</span>
            <span class="font-bold text-rose-500">-{{ record?.wh | number:'1.2-2' }} ฿</span>
          </div>

          <!-- Divider -->
          <div class="h-px bg-gradient-to-r from-transparent via-slate-200 dark:via-slate-700 to-transparent my-1">
          </div>

          <!-- Total -->
          <div class="flex justify-between items-center">
            <span class="text-[12px] font-extrabold text-slate-800 dark:text-slate-100">ยอดชำระสุทธิ (Total)</span>
            <div class="flex items-baseline gap-1">
              <span class="text-[22px] font-black text-amber-500 dark:text-amber-400 leading-none">{{ record?.total |
                number:'1.2-2' }}</span>
              <span class="text-[10px] font-bold text-amber-500/80 dark:text-amber-400/80">฿</span>
            </div>
          </div>
        </div>
      </div>

      <app-finance-attachments *ngIf="record?.id" [financeId]="record?.id" [siteId]="siteId" [userId]="userId"
        title="หลักฐานการชำระเงิน">
      </app-finance-attachments>

      <!-- Pending Approval Banner -->
      <div *ngIf="record?.pendingApprovalRequestId"
        class="flex gap-3 rounded-2xl px-4 py-3 bg-amber-50/80 dark:bg-amber-950/20 border border-amber-200/60 dark:border-amber-800/30 backdrop-blur-sm">
        <span class="material-icons text-amber-500 text-lg mt-0.5 flex-shrink-0">pending_actions</span>
        <div>
          <p class="text-[11px] font-black text-amber-700 dark:text-amber-400">อยู่ระหว่างรอการอนุมัติยกเลิก</p>
          <p class="text-[10.5px] mt-0.5 text-amber-600/80 dark:text-amber-400/70 leading-relaxed">
            คำร้องขอยกเลิก #{{ record?.pendingApprovalRequestId }} ได้รับการส่งเข้าระบบแล้ว กำลังรอผู้ดูแลอนุมัติ
          </p>
        </div>
      </div>

    </div>

    <!-- ── Footer Buttons ── -->
    <div
      class="flex-shrink-0 px-6 pb-6 pt-3 flex items-center justify-between gap-2 border-t border-slate-100/80 dark:border-slate-800/50">

      <button *ngIf="canShowActivityHistory" type="button" (click)="openActivityHistory()" class="h-9 px-4 rounded-xl text-slate-600 dark:text-slate-300 font-semibold text-[12px]
               bg-white dark:bg-slate-800/60 hover:border-amber-400 hover:text-amber-600
               border border-slate-200/60 dark:border-slate-700/40 transition-all active:scale-[0.97]
               cursor-pointer backdrop-blur-sm inline-flex items-center gap-1.5">
        <span class="material-icons text-[15px]">history</span>
        ดูประวัติ
      </button>

      <div class="flex items-center justify-end gap-2 ml-auto">
      <!-- Close -->
      <button (click)="onClose()" class="h-9 px-4 rounded-xl text-slate-500 dark:text-slate-400 font-semibold text-[12px]
               bg-slate-100/80 dark:bg-slate-800/60 hover:bg-slate-200/80 dark:hover:bg-slate-700/60
               border border-slate-200/60 dark:border-slate-700/40 transition-all active:scale-[0.97]
               cursor-pointer backdrop-blur-sm">
        ปิด
      </button>

      <!-- View Receipt -->
      <button (click)="onViewReceipt()" class="h-9 px-4 rounded-xl font-bold text-[12px] flex items-center gap-1.5
               bg-slate-800/90 dark:bg-slate-700/80 hover:bg-slate-900 dark:hover:bg-slate-600
               text-white border border-slate-700/40 dark:border-slate-600/40
               shadow-[0_4px_12px_rgba(15,23,42,0.2)] transition-all active:scale-[0.97]
               cursor-pointer backdrop-blur-sm">
        <span class="material-icons text-[15px]">receipt</span>
        ดูใบเสร็จ
      </button>

      <!-- Cancel -->
      <button
        *ngIf="hasEditPermission && record?.canCancel && !record?.pendingApprovalRequestId && isToday(record?.paidDate)"
        (click)="onCancel()" class="h-9 px-4 rounded-xl font-bold text-[12px]
               bg-rose-500 hover:bg-rose-600 text-white
               shadow-[0_4px_12px_rgba(244,63,94,0.3)] border-none
               transition-all active:scale-[0.97] cursor-pointer">
        ยกเลิกรายการ
      </button>
      </div>
    </div>

  </div>
</div>

<app-modal-admin-activity-history
  *ngIf="showActivityHistory && record?.id"
  [entityType]="activityEntityTypes.Finance"
  [entityId]="record!.id"
  title="ประวัติรายการรับชำระ"
  [subtitle]="'#' + record!.id"
  (close)="closeActivityHistory()">
</app-modal-admin-activity-history>